<table
    mat-table
    [dataSource]="dataSource"
    class="w-full"
    attr.aria-label="{{ 'shared.fileUploadDragDrop.tableLabel' | translate }}">
    <!-- FileName Column -->
    <ng-container matColumnDef="{{ columns.fileName }}">
        <th mat-header-cell *matHeaderCellDef>
            {{ 'shared.fileUploadDragDrop.tableColNames.fileName' | translate }}
        </th>
        <td mat-cell *matCellDef="let file" [title]="file.file.name">
            <div class="flex items-center">
                <span class="inline-block max-w-[200px] truncate">
                    {{ file.file.name }}
                </span>
            </div>
        </td>
    </ng-container>
    <!-- Size Column -->
    <ng-container matColumnDef="{{ columns.size }}">
        <th mat-header-cell *matHeaderCellDef>
            {{ 'shared.fileUploadDragDrop.tableColNames.size' | translate }}
        </th>
        <td mat-cell *matCellDef="let file">
            {{ formatUploadedFileSize(file.file.size, DEFAULT_DECIMAL_POINTS) }}
        </td>
    </ng-container>
    <!-- Status Column -->
    <ng-container matColumnDef="{{ columns.status }}">
        <th mat-header-cell *matHeaderCellDef>
            {{ 'shared.fileUploadDragDrop.tableColNames.status' | translate }}
        </th>
        <td mat-cell *matCellDef="let file">
            @let pct = file.percentage | async;
            <div class="flex gap-2 items-center">
                <mat-progress-bar
                    [value]="pct ?? 0"
                    attr.aria-label="{{
                        'shared.fileUploadDragDrop.progressBarLabel' | translate
                    }}"
                    class="min-w-[40px]" />
                <div class="ms-2 flex justify-center items-center">
                    @if (pct !== 100) {
                        <apcam-loading-spinner size="sm" />
                    } @else {
                        <mat-icon color="primary">
                            check_circle_outline
                        </mat-icon>
                    }
                </div>
            </div>
        </td>
    </ng-container>
    <!-- Action Column -->
    <ng-container matColumnDef="{{ columns.action }}">
        <th mat-header-cell *matHeaderCellDef>
            {{ 'shared.fileUploadDragDrop.tableColNames.action' | translate }}
        </th>
        <td mat-cell *matCellDef="let file; let i = index">
            @let pct = file.percentage | async;
            <div>
                <apcam-tooltip-custom
                    customMatTooltip="{{
                        'shared.fileUploadDragDrop.deleteFileBtnTooltip'
                            | translate
                    }}"
                    [customMatTooltipDisabled]="pct === 100">
                    @if (!filesDeleting().get(file)) {
                        <button
                            mat-icon-button
                            attr.aria-label="{{
                                'shared.fileUploadDragDrop.deleteFileBtn'
                                    | translate
                            }}"
                            color="warn"
                            [disabled]="pct !== 100"
                            type="button"
                            title="{{
                                'shared.fileUploadDragDrop.deleteFileBtn'
                                    | translate
                            }}"
                            (click)="removeFile(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    } @else {
                        <!-- deleteUiRevision: forces re-eval of filesDeleting.get(file) after WeakMap updates -->
                        <span class="sr-only" aria-hidden="true">{{
                            deleteUiRevision()
                        }}</span>
                        <apcam-loading-spinner size="sm" />
                    }
                </apcam-tooltip-custom>
            </div>
        </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
